import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "27",
  height: "27",
  fill: "currentColor",
  viewBox: "0 0 27 27"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#icon-arrow-left)" }, [
  /*#__PURE__*/_createElementVNode("path", { d: "M12.938 3.514c-2.907 2.784-5.78 5.531-8.682 8.312.543.03 1.02.071 1.497.071 6.751.005 13.507 0 20.258 0 .23 0 .46-.042.69-.05.121-.004.295-.063.299.155v2.08H4.308c-.017.025-.034.05-.052.07 2.873 2.781 5.75 5.566 8.626 8.347-.49.474-.968.928-1.432 1.394-.152.151-.256.135-.4-.004a824.902 824.902 0 0 0-3.41-3.305L.188 13.367c-.246-.239-.25-.475-.01-.71 3.49-3.377 6.982-6.753 10.47-10.13.13-.126.278-.244.395-.387.152-.185.27-.185.443-.012.46.457.941.894 1.453 1.381v.005Z" })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "icon-arrow-left" }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M0 0h27v27H0z" })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }